import * as React from "react";
import { Grid } from "../grid/grid";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const buttonTabsButtonClass = css({
    userSelect: "none",
    ":first-of-type": {
        borderRadius: "4px 0px 0px 4px",
    },
    ":last-of-type": {
        borderRadius: "0px 4px 4px 0px",
    },
    zIndex: 0,
    color: getThemeColorVar("typo", "light"),
    borderColor: getThemeColorVar("border", "default"),
    ":not(:first-of-type)": {
        marginLeft: "-1px",
    },
    backgroundRepeat: "no-repeat",
    cursor: "pointer",
    textAlign: "center",
    whiteSpace: "nowrap",
    fontSize: "14px",
    lineHeight: "14px",
    padding: "7px 16px",
    borderWidth: "1px",
    borderStyle: "solid",
});
const buttonTabsSelectedClass = css({
    cursor: "inherit",
    color: getThemeColorVar("white", undefined),
    borderColor: getThemeColorVar("primary", "default"),
    backgroundColor: getThemeColorVar("primary", "default"),
    zIndex: 1,
});
export class ButtonTabs extends React.Component {
    render() {
        return (React.createElement("div", null,
            React.createElement(Grid, { columns: this.props.values.length }, this.props.values.map((value) => {
                const classes = [buttonTabsButtonClass];
                if (value === this.props.selected) {
                    classes.push(buttonTabsSelectedClass);
                }
                const translatedValue = this.props.translate
                    ? this.props.translate(value)
                    : value;
                return (React.createElement("div", { key: value, onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.props.onSelect && this.props.onSelect(value);
                    }, className: cx(classes) }, translatedValue));
            }))));
    }
}
export default ButtonTabs;
//# sourceMappingURL=buttontabs.js.map